var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g, _path38, _ellipse, _path39, _ellipse2, _path40, _ellipse3, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _rect, _rect2, _rect3, _rect4, _rect5, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g2, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g3, _path80, _path81, _polygon, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _ellipse4, _path95, _polygon2, _polygon3, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTodo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "59904e4f-d552-4f96-882a-6a294bb87dd0",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1155.41,
    height: 796.48,
    viewBox: "0 0 1155.41 796.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a0337754-c09d-4430-960e-4dcfef50d642",
    x1: 880.14,
    y1: 757.49,
    x2: 880.14,
    y2: 274.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "to do list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.06,92C418.26,56.69,479.8,49.5,535.81,52.31c175.93,8.83,334.74,94.59,472.11,191.6,49.73,35.12,98.69,73,131,121.33,65.72,98.45,46.22,234.84-45.15,315.94-31.09,27.6-68.78,48.75-107.47,67.51-68.79,33.34-143,60.1-221.09,67.72-55.68,5.43-112,1-167.4-6.56-154.65-21.18-306.45-68-433.69-148.14C108.29,626.57,55.69,582.88,32.69,526s-8.28-128.89,48.7-162.54c23.57-13.92,51.74-20.2,79.33-26.11,40.61-8.68,81.86-17.25,118.51-34.91,37.85-18.24,82.66-53.52,75.17-93.9C346.36,165.25,339.91,127.2,379.06,92Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279,499.57s10.37-7.43,21.1-2.84c0,0-3,6.38-16.37,6.3Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.71,500s-2.77,12.45,5.67,20.53c0,0,4.68-5.27-.64-17.53Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264,488.67s.38-10.51,24.18-7.94c0,0,.37,6.76-7.81,10.28S268.27,492,264,488.67Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.53,488.65s-9.89,3.6-.11,25.46c0,0,6.54-1.73,7.37-10.6S267,491.71,262.53,488.65Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.56,474.3s-2-17.2,22.24-16.36c0,0,2.31,15.55-17.81,20.34Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M231.83,455.44s2.57-19.67,27-14.78c0,0,.74,16.9-22.84,19.29Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219.38,435.75s4.82-19.29,29-14.47c0,0-5,17.35-27.27,17.93Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.53,416.52s4.67-20,28-14.92c0,0-7,19.07-26.37,18.23Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M199.66,398.12s3.25-24.33,25-19.81c0,0-5.42,22.23-23.3,23.26Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M192.09,375.81s4.07-24.55,26.15-18.3c0,0-7.68,23.35-24.5,21.61Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.13,355s7-24.66,23.92-24.65c0,0-7.15,26-22.32,29.48Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183.71,334.58s7.53-29.66,21.35-27.92c0,0-5.13,22.64-20.69,32.47Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.28,310.16s7.17-24.74,20.69-26.24c0,0-4.6,24.25-20.15,32.58Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M178.76,287.44s9.18-24.85,18.12-25.75c0,0-3.47,24.25-17.07,29.73Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176.83,266.26s5.2-26.81,14.06-29.35c0,0-.39,21.77-13.09,31.3Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M172.4,238.62s5.73-21.42,12.85-24.93c0,0-.48,25-11,30Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M168.9,220.48l-2.75-37.28s14.6,27.66,4,43.83Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157,183.78s-10.79-26.89-13.19-28.32c0,0,19.8,17,18.8,39.78Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M247.9,474.2s-17.25-1.59-15.8,22.63c0,0,15.6,1.93,19.89-18.31Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M231,454.82s-19.82.69-17.26,25.44c0,0,16.75,2.34,21.36-20.91Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M219.25,437.37s-18.32-7.75-29,14.47c0,0,16.89,6.39,30.72-11Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M207.13,416.72s-18.76-8.28-28.77,13.42c0,0,19.45,5.87,30.42-10.12Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M199.91,398.63s-18.38-16.26-31.87,1.42c0,0,18.65,13.24,32.83,2.32Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M193.07,375.19s-18.5-16.64-31.85,2c0,0,20.57,13.45,32.63,1.59Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M188.93,354.21s-14.57-21.1-30.57-15.66c0,0,15.14,22.36,30.61,20.75Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M184.12,334.43s-14.91-26.72-27.81-21.49c0,0,10.78,20.56,28.33,26.05Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17,308.73s-15.06-20.9-28.29-17.77c0,0,12.47,21.3,29.91,23.93Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M180.25,286.9s-11.95-23.64-20.93-23.51c0,0,6.21,23.7,20.34,27.58Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M177.25,265.72s-13.2-23.9-22.42-23.6c0,0,7.08,20.6,22.09,25.76Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M174.42,240s-9.95-19.82-17.63-21.81c0,0,5.53,24.4,16.82,27.2Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M167.78,219.82l-21.69-30.44S152.52,220,171,225.66Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.41,186.47S128,170.94,127,168.31c0,0,13,22.58,35.66,25.78Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M150.7,179.13s-28.36-25.25-35.34-24.95c0,0,22.6.16,36,23.53Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M174.3,244l-1,.17c-6.68-40.05-15.09-63.54-23.67-66.16l.29-1C159,179.77,167.46,202.92,174.3,244Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#444053"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M185.55,339.88l-1.5.18c-.46-3.74-.86-7.58-1.17-11.4-2.71-33.25-6.11-63.75-9.91-86.57l.83-1.11c3.81,22.86,7.87,54.26,10.59,87.56C184.7,332.34,185.09,336.15,185.55,339.88Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#444053"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M307.83,517.65c-.27-.11-27.23-10.93-55.83-38.11a218.64,218.64,0,0,1-41.84-54.7c-13.71-25.41-22.68-56.95-26.47-87.77l1.6.68c8.5,69.18,41.92,115.42,68,140.27,28.32,26.94,55,37.65,55.25,37.75Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#444053"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.84,436.21s12.11-4,21,3.57c0,0-4.77,5.2-17.51,1.14Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.48,436.23s-6.34,11.07-.69,21.28c0,0,6-3.63,4.61-16.92Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.75,421.34s3.5-9.92,25.45-.39c0,0-1.65,6.57-10.52,7.49S312.85,425.77,309.75,421.34Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.36,420.89s-10.5.5-7.68,24.27c0,0,6.77.3,10.2-7.93S311.72,425.13,308.36,420.89Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.3,403s3.19-17,26.09-9c0,0-2.41,15.53-23.05,14.12Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,380s8.3-18,30.14-6.08c0,0-4.32,16.35-27.55,11.62Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.9,357.55s10.35-17,32-5.19c0,0-10,15.06-31.37,9Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.31,335.66s10.4-17.68,31.19-5.91c0,0-12.35,16.12-30.59,9.56Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.27,315.75s10.34-22.26,29.78-11.46c0,0-11.79,19.6-29.16,15.27Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.69,292.2s11.19-22.23,30.4-9.69c0,0-14.27,20-29.81,13.34Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.16,270.83s14-21.46,30.16-16.42c0,0-14.57,22.73-30.08,21.51Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,250.34s16-26.07,28.69-20.3c0,0-11.64,20.09-29.41,24.84Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,226.31s14.22-21.49,27.56-18.9c0,0-11.6,21.79-28.92,25.11Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.26,203.86s16.15-21,24.95-19.18c0,0-10.53,22.12-25.14,23.29Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.71,183.07s12.94-24,22.16-23.84c0,0-6.86,20.67-21.81,26Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.7,155.36s11.85-18.74,19.69-20c0,0-7.9,23.74-19.42,25.41Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.76,137l8.47-36.42s5.71,30.75-9.23,43Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34,98.43s-2.31-28.88-4.17-31c0,0,13.86,22.08,6.12,43.58Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.69,402.73s-16-6.64-21.81,16.92c0,0,14.31,6.48,24.43-11.57Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32,379.2s-19.13-5.23-24.05,19.16c0,0,15.3,7.22,26.62-13.61Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,359.05s-15.18-12.85-32,5.19c0,0,14.22,11.13,32.61-1.38Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.88,335.73s-15.46-13.48-31.46,4.25c0,0,16.82,11.4,32.05-.6Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.37,316.32s-12.72-21-30.86-8.14c0,0,13.87,18.2,30.66,12Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.81,291.9s-12.72-21.39-31-7.55c0,0,15.64,19,30.67,11.23Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.09,270.63s-7.63-24.47-24.52-24c0,0,7.8,25.86,23.05,28.92Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.38,250.32s-6.28-29.95-20.15-28.79c0,0,4.18,22.84,19.3,33.31Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.18,225.21s-8.16-24.44-21.73-25.39c0,0,5.57,24.05,21.44,31.75Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.84,203.79s-4.38-26.12-13-28.67c0,0-1.11,24.47,11.22,32.39Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.27,182.68s-5.49-26.75-14.38-29.2c0,0,.63,21.77,13.43,31.16Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21,157.32s-3.6-21.88-10.34-26.07c0,0-2,24.94,8,31Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.89,136l-11.66-35.52s-3,31.14,13,42.05Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.14,99.63s-18.73-22.11-18.87-24.9c0,0,5.73,25.43,26.37,35.22Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.69,92.12s-19.57-32.55-26.32-34.35c0,0,21.52,6.89,27.32,33.16Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.93,161l-1-.14c5.53-40.21,4.5-65.15-2.92-70.2l.57-.83C301.45,95.2,302.6,119.81,296.93,161Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.13,256l-1.49-.27c.68-3.71,1.44-7.49,2.28-11.24,7.31-32.55,13.14-62.67,16.29-85.59l1.13-.82c-3.16,23-8.63,54.15-15.94,86.75C280.56,248.5,279.8,252.26,279.13,256Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,462.05c-.22-.18-22.74-18.53-42-53a218.47,218.47,0,0,1-23.66-64.67c-5.53-28.34-4.72-61.12.84-91.67l1.32,1.12C267.05,322.41,285.2,376.51,302.74,408c19,34.14,41.28,52.3,41.51,52.48Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#444053"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.65,805.87s-42.28-2.55-37.29,27.08c0,0-1,5.23,3.75,7.61,0,0,.08-2.2,4.34-1.45a19.36,19.36,0,0,0,4.59.22,9.62,9.62,0,0,0,5.62-2.32h0s11.88-4.91,16.5-24.33c0,0,3.42-4.24,3.29-5.33l-7.14,3s2.44,5.15.52,9.42c0,0-.23-9.23-1.6-9-.28.05-3.71,1.79-3.71,1.79s4.2,9,1,15.48c0,0,1.2-11.05-2.34-14.84l-5,2.94s4.9,9.26,1.58,16.81c0,0,.85-11.59-2.64-16.1l-4.55,3.55s4.61,9.13,1.8,15.39c0,0-.37-13.49-2.78-14.51,0,0-4,3.51-4.59,5,0,0,3.15,6.62,1.2,10.12,0,0-1.2-9-2.19-9,0,0-4,5.95-4.38,10,0,0,.17-6.07,3.42-10.6a11.89,11.89,0,0,0-6.07,3.14s.62-4.21,7-4.58c0,0,3.28-4.51,4.16-4.79,0,0-6.41-.53-10.29,1.19,0,0,3.42-4,11.46-2.17l4.49-3.67s-8.43-1.15-12,.12c0,0,4.11-3.51,13.21-.95l4.89-2.92s-7.18-1.55-11.46-1c0,0,4.52-2.44,12.9.2l3.5-1.57s-5.27-1-6.81-1.2-1.62-.59-1.62-.59a18.22,18.22,0,0,1,9.88,1.1S1036.78,806.34,1036.65,805.87Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 985.23,
    cy: 791.38,
    rx: 29.92,
    ry: 5.06,
    fill: "#ec6374",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.75,727.8s-23.83-1.43-21,15.27a4.07,4.07,0,0,0,2.11,4.29s.05-1.24,2.45-.82a10.62,10.62,0,0,0,2.59.13,5.35,5.35,0,0,0,3.16-1.31h0s6.7-2.77,9.31-13.72c0,0,1.93-2.39,1.85-3l-4,1.72s1.37,2.9.29,5.31c0,0-.13-5.21-.9-5.08-.16,0-2.09,1-2.09,1s2.36,5.06.58,8.73c0,0,.68-6.23-1.32-8.36l-2.83,1.65s2.76,5.22.89,9.48c0,0,.48-6.53-1.49-9.08l-2.56,2s2.59,5.15,1,8.68c0,0-.21-7.6-1.57-8.18a16,16,0,0,0-2.59,2.79s1.78,3.74.68,5.71c0,0-.68-5.07-1.23-5.09,0,0-2.24,3.36-2.47,5.66a12.22,12.22,0,0,1,1.93-6,6.74,6.74,0,0,0-3.43,1.77s.35-2.37,4-2.58c0,0,1.85-2.55,2.34-2.7,0,0-3.61-.3-5.8.67,0,0,1.93-2.24,6.46-1.23l2.54-2.06s-4.76-.65-6.77.07c0,0,2.32-2,7.45-.54l2.76-1.65a25.22,25.22,0,0,0-6.47-.56s2.55-1.37,7.27.12l2-.89s-3-.58-3.84-.67-.92-.34-.92-.34a10.32,10.32,0,0,1,5.58.62S1117.82,728.07,1117.75,727.8Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1079.04,
    cy: 697.06,
    rx: 16.87,
    ry: 2.85,
    fill: "#ec6374",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M977.06,742.3s-28.78-1.74-25.38,18.43a4.91,4.91,0,0,0,2.55,5.18s0-1.49,2.95-1a13.73,13.73,0,0,0,3.13.16,6.58,6.58,0,0,0,3.82-1.58h0s8.09-3.34,11.24-16.57c0,0,2.33-2.88,2.23-3.62l-4.85,2.07s1.66,3.51.35,6.42c0,0-.15-6.29-1.09-6.14-.19,0-2.52,1.21-2.52,1.21s2.85,6.11.7,10.54c0,0,.82-7.52-1.59-10.1l-3.42,2s3.33,6.3,1.07,11.45c0,0,.58-7.89-1.79-11l-3.1,2.41s3.14,6.21,1.23,10.48c0,0-.25-9.18-1.9-9.88,0,0-2.71,2.39-3.12,3.37,0,0,2.14,4.51.81,6.89,0,0-.81-6.11-1.48-6.14,0,0-2.7,4.05-3,6.83a14.77,14.77,0,0,1,2.33-7.22,8.13,8.13,0,0,0-4.13,2.14s.42-2.87,4.8-3.12c0,0,2.23-3.07,2.83-3.26,0,0-4.36-.36-7,.81,0,0,2.32-2.71,7.79-1.48l3.06-2.49s-5.73-.79-8.17.08c0,0,2.8-2.39,9-.65l3.33-2s-4.89-1.06-7.81-.68c0,0,3.08-1.65,8.78.14L971.1,745s-3.58-.7-4.63-.81-1.1-.4-1.1-.4a12.43,12.43,0,0,1,6.73.75S977.15,742.62,977.06,742.3Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 934.94,
    cy: 715.91,
    rx: 20.37,
    ry: 3.44,
    fill: "#ec6374",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M736.37,752.76,636.06,791.57,489.44,848.24c-5.53-10.27-13.69-24.32-23.79-41-34.72-57.55-92.18-147.06-143.32-225.72-57.64-88.63-107.24-163.47-107.24-163.47L251,407.64l293.32-85.07Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M738.37,745.76,638.06,784.57,491.44,841.24c-5.53-10.27-13.69-24.32-23.79-41-34.72-57.55-92.18-147.06-143.32-225.72-57.64-88.63-107.24-163.47-107.24-163.47L253,400.64l293.32-85.07Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M738.37,745.76,638.06,784.57a754.4,754.4,0,0,1-170.41,15.67c-34.72-57.55-92.18-147.06-143.32-225.72L253,400.64l293.32-85.07Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M813,721.62S657.16,813.8,424.5,793L239,340.81l88.89-15.27,307.28-52.77L809.52,712.88Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M809.52,712.88c-36.7,1.8-79.14,1.63-121.86-3.46C641.44,704,595,692.78,555.1,672.24c-33.32-17.17-61.81-35.82-86.66-58.21-64.61-58.12-104.6-141.26-140.51-288.49l307.28-52.77Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M923.83,687.6s-114.92,22.52-231.78,8.65c-46.22-5.45-92.71-16.64-132.56-37.18-33.32-17.17-61.81-35.82-86.66-58.21-80-72-122.21-182.22-165.75-404.91,0,0,191,46.09,379.71-54.87C686.79,141.08,750.44,538.35,923.83,687.6Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M692.05,696.25c-46.22-5.45-92.71-16.64-132.56-37.18-33.32-17.17-61.81-35.82-86.66-58.21,68.09-5.53,77.88-42.76,77.88-42.76C601.19,638.22,692.05,696.25,692.05,696.25Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M405.85,277.71s102.6,11.71,198.63-42.25l6.58,21.13S519.19,302.4,405.85,302.4Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ec6374",
    opacity: 0.3
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M405.85,382s102-8.23,215.55-63.11l3.84,8.78S583.45,380.26,405.85,394Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M417.94,422.68s102-8.23,215.55-63.1l3.84,8.78S595.55,421,417.94,434.75Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.3
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M429,466.53s102-8.23,215.55-63.1l3.84,8.78S606.55,464.82,429,478.6Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.3
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M442.13,504.11s102-8.23,215.55-63.1l3.84,8.78s-41.78,52.62-219.39,66.4Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.3
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M454.23,544.83s102-8.23,215.55-63.1l3.84,8.78s-41.79,52.62-219.39,66.39Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 642.3,
    y: 295.52,
    width: 30.15,
    height: 30.15,
    transform: "translate(-87.32 176.7) rotate(-18.8)",
    fill: "#ec6374",
    opacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 658.54,
    y: 337.98,
    width: 30.15,
    height: 30.15,
    transform: "translate(-100.14 184.2) rotate(-18.8)",
    fill: "#ec6374",
    opacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 684.58,
    y: 419.68,
    width: 30.15,
    height: 30.15,
    transform: "translate(-125.09 196.95) rotate(-18.8)",
    fill: "#ec6374",
    opacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 699.51,
    y: 463.53,
    width: 30.15,
    height: 30.15,
    transform: "translate(-138.42 204.1) rotate(-18.8)",
    fill: "#ec6374",
    opacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 671.78,
    y: 382.09,
    width: 30.15,
    height: 30.15,
    transform: "translate(-113.65 190.82) rotate(-18.8)",
    fill: "#ec6374",
    opacity: 0.3
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M994.7,501.33l-1.07-1c2.76-.56,5.36-.81,5.36-.81s-9.47-34.26-25.44-45.69c-7.9-5.65-14.48-15.06-19.13-23.13a349.7,349.7,0,0,0-28.49-41.77l-2.88-3.63-1.24-1.58c1.73-2.62,3.85-5.11,3.61-8.15a.13.13,0,0,1,0-.06,3.84,3.84,0,0,0,0-.48,5.59,5.59,0,0,0-.2-1.11l-.11.17c-1.35-3.92-6.54-5.65-10.39-7.81-9-5.07-12.85-16.15-14.77-26.45-1.5-8-2.74-17-9-22.15-4-3.31-9.44-4.4-13.47-7.69-3.82-3.12-5.95-7.85-8.35-12.2-4-7.25-9.28-14-16.25-18.33s-15.82-6-23.47-3.1c-2.93,1.12-5.59,2.86-8.49,4.07-7.2,3-15.45,2.6-22.58,5.77-8.78,3.9-14.49,12.52-19.71,20.7-2.7,4.23-6.94,10.42-9.35,16.65,0-.22,0-.43,0-.65a23.82,23.82,0,0,0-1.86,8.66,13,13,0,0,0,.41,3.76c1.08,4,4.3,6.21,8.12,7.75a33.85,33.85,0,0,0,.88,3.77,37,37,0,0,0,23.9,24.41c.33.12.67.2,1,.3a7.94,7.94,0,0,0,1.19,2.2c3.19,4,9.59,2.86,13.75-.05.17-.11.33-.25.49-.37a15,15,0,0,0,.18,1.69c.09.48.16,1,.26,1.43,3.75,20.21,13.35,31.12,13.35,31.12s.89,1.34,2.34,3.56c-.76,11.15,4.33,21.31,10.21,29.16-5.07,2.93-16,8.67-22.76,8.19,0,0-24.84,3.21-27.72,1.6-.4-.22-.78.08-1.14.76-6.84-4.17-28.71-16.19-30.58-.76-1.69,14,18.24,15.79,27.73,15.86-.43,4.1-.67,7.38-.67,7.38l40.81-2.79,21.25-3.13c-2.35,3.11-5,5.88-7.59,7.23,0,0-19.21,15.55-22.53,15.69-.47,0-.62.47-.55,1.22-8.08,0-33.21,1.17-26.24,15.17,6.33,12.69,24.15,3.91,32.21-.94,1.9,3.69,3.52,6.58,3.52,6.58l32.93-23.45,7.13-6a25.38,25.38,0,0,0,7.09-1.37c0,.09.07.18.1.26a13.53,13.53,0,0,1,.57,2.26c2,11.49-4.72,38.29-4.72,38.29s-14.78,37.69-7.68,42.83S866.51,592,866.51,592a40.1,40.1,0,0,0,4.26,5.88h0a17.86,17.86,0,0,0,2.49,2.37,23.15,23.15,0,0,0-.82,2.75,22.42,22.42,0,0,0,1.17,13.84c4.88,11.84,1.91,29,1.91,29l-9.58,64.72c-4.6-.7-10.54-1.28-12.75,0-3.39,1.91-2.28,11.54,5.59,15.68a20.26,20.26,0,0,1-8.1,3.73c-7,1.6-11.92,2.62-15.16,3.24-.21,0-16.8-3.66-21.06-1.24s-2.21,15.84,9.91,19.13c11.86,3.21,56.09,7.92,68.83,6l.81-.14c10.83-2.14,1.32-16.37.12-18.1-.08-.58-.15-1.19-.23-1.85-.17-1.48-.32-3.18-.43-5,12.08,1.11,24,1.65,29.47.83.26,0,.5-.08.72-.13,9.59-1.9,1.19-14.48.11-16q-.07-.58-.15-1.23v-.11c0-.29-.07-.6-.1-.9s0-.51-.08-.78,0-.48-.07-.73q-.06-.74-.12-1.53c0-.21,0-.43,0-.65,0-.4-.05-.8-.07-1.21,0-.22,0-.44,0-.67,0-.6,0-1.22-.06-1.84,0-.17,0-.34,0-.51,0-.5,0-1,0-1.52,0-.24,0-.48,0-.73,0-.53,0-1.06,0-1.6,0-.18,0-.35,0-.53,0-.67.06-1.36.1-2.05l.06-.74c0-.51.08-1,.13-1.52,0-.25,0-.5.08-.75.08-.7.17-1.4.27-2.11,0-.21.07-.42.1-.63.09-.53.18-1.07.28-1.61,0-.26.1-.53.16-.8q.18-.87.39-1.74c0-.16.07-.32.11-.48.18-.7.38-1.39.59-2.08.07-.24.15-.48.23-.72.17-.52.35-1,.54-1.54l.24-.64c.27-.68.56-1.35.86-2,.08-.17.17-.34.26-.51.25-.52.52-1,.8-1.54l.34-.59c.38-.64.77-1.28,1.2-1.89,11-15.68,13.9-45.92,13.63-52.5s1.31-20.23,3.28-22.25c1.32-1.35,9-12,13.59-20.1.83-1.48,1.55-2.87,2.12-4.11,3.26-1.13,5.42-2,5.42-2v0h0a46.37,46.37,0,0,1-1.64-12.89c.08-8.51,2.42-19.72,12.08-28.82,14.26-13.44,16.25-26.76,16.44-31.88,0-.36,0-.68,0-.95C994.75,501.79,994.7,501.33,994.7,501.33Z",
    transform: "translate(-22.3 -51.76)",
    fill: "url(#a0337754-c09d-4430-960e-4dcfef50d642)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M956.7,585.2a171.88,171.88,0,0,1-13,19.87c-1.88,2-3.39,15.51-3.13,22s-2.49,36.41-13,51.91-5.11,42.29-5.11,42.29l-16.77,5.88H885.54L871.66,723,868,712.9s4.88-.75,17-3.63A15.73,15.73,0,0,0,897.55,695l8.51-59.43s2.51-15-1.63-25.38a20.66,20.66,0,0,1,1.36-18.1l.27-.42s13.13-10.37,26.51-16.86c11.85-5.72,23.87-8.44,27.28,1.71C960.29,577.83,958.85,581.2,956.7,585.2Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#a5636d"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M956.7,585.2a171.88,171.88,0,0,1-13,19.87c-1.88,2-3.39,15.51-3.13,22s-2.49,36.41-13,51.91c-7.4,10.93-6.91,27.45-6,36.26.39,3.69.87,6,.87,6l-16.77,5.88H885.54L871.66,723,868,712.9s1.22-.19,4-.73,7-1.46,13.06-2.9A15.73,15.73,0,0,0,897.55,695l8.51-59.43s2.51-15-1.63-25.38a20.66,20.66,0,0,1,1.36-18.1l.27-.42s13.13-10.37,26.51-16.86c11.85-5.72,23.87-8.44,27.28,1.71C960.29,577.83,958.85,581.2,956.7,585.2Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.05
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M922.46,721.28l-16.77,5.88H885.54L871.66,723,868,712.9s1.22-.19,4-.73a7.55,7.55,0,0,0,5.81,8.16l7.88.27c1.11,0,2.23.06,3.33.06a100.48,100.48,0,0,0,32.58-5.41C922,718.94,922.46,721.28,922.46,721.28Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M885.68,722.3l-7.89-.27s-7.36-1.56-5.56-9.91c0,0-14.2-3.22-17.83-1.09s-1.88,13.88,8.38,16.76c10,2.81,47.46,6.94,58.23,5.25l.69-.12c9.76-2,0-16,0-16h0A100.88,100.88,0,0,1,885.68,722.3Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#bebed0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M934.27,587.5c-.53,1.06-1.1,2.16-1.75,3.31-4.95,9-12.89,20.33-14.28,21.8-2.12,2.26-3.81,17.5-3.54,24.86s-2.81,41.08-14.67,58.58c-6.07,9-7.44,21.25-7.34,31.11a100.24,100.24,0,0,0,.59,10c.44,4.07,1,6.61,1,6.61l-18.92,6.63H852.59l-15.67-4.66-4.1-11.44s1.37-.22,4.45-.83,7.88-1.63,14.74-3.25a17.78,17.78,0,0,0,14.13-16.1l9.59-67.07s2.83-16.95-1.83-28.65a23,23,0,0,1-1.12-13.69,21.84,21.84,0,0,1,3-7.22s3.66-2.88,9.18-6.69c2.44-1.68,5.27-3.54,8.31-5.42,13.36-8.27,30.93-16.71,39.35-10.56a10.89,10.89,0,0,1,3.88,5.59C936.84,581.57,935.89,584.2,934.27,587.5Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#a5636d"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M894.23,743.78l-18.92,6.63H852.59l-15.67-4.66-4.1-11.44s1.37-.22,4.45-.83a8.35,8.35,0,0,0,2.66,7.39,8.91,8.91,0,0,0,5.64,2.12l7.17.23c1.25,0,2.51.07,3.76.07a113.75,113.75,0,0,0,36.78-6.12C893.72,741.24,894.23,743.78,894.23,743.78Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M852.73,744.92l-7.16-.24a9,9,0,0,1-5.65-2.12c-1.82-1.62-3.39-4.42-2.37-9.13,0,0-16-3.63-20.13-1.23s-2.11,15.67,9.46,18.92c11.33,3.17,53.57,7.83,65.73,5.93l.77-.14c11-2.26,0-18.08,0-18.08h0A113.46,113.46,0,0,1,852.73,744.92Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#bebed0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M956.7,585.2c-6.85,2.39-16.91,5.56-22.43,5.69a10.06,10.06,0,0,1-1.71-.08h0c-3.86-.53-15.79.32-26.73,1.3-4.39.39-8.61.8-12.1,1.16-5.2.54-8.78.93-8.78.93v-3.39c2.44-1.68,5.27-3.54,8.31-5.42,13.36-8.27,30.93-16.71,39.35-10.56,11.85-5.72,23.87-8.44,27.28,1.71C960.29,577.83,958.85,581.2,956.7,585.2Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M989.57,506.33c-.19,5.07-2.09,18.23-15.71,31.53-17.36,16.95-10,41.29-10,41.29s-20.7,8.13-29.63,8.35a10.06,10.06,0,0,1-1.71-.08c-5.36-.75-26.64,1.22-38.87,2.46-5.2.54-8.78.93-8.78.93v-72l95.93-23.29,8.69,8.65A16,16,0,0,1,989.57,506.33Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#5c5c8e"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M955.5,576.89",
    transform: "translate(-22.3 -51.76)",
    fill: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M886.49,589.92l-1.58.17v.76s3.58-.39,8.78-.93c8.78-.89,22.19-2.14,31.06-2.51C918.61,586.85,898.33,588.72,886.49,589.92Z",
    transform: "translate(-22.3 -51.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.53,504.21l-8.69-8.66L975.05,497l7.28,7.25a16,16,0,0,1,0,2.17c-.19,5.06-2.09,18.23-15.71,31.53-17.36,16.94-10,41.29-10,41.29s-17.13,6.72-26.94,8.11a24.73,24.73,0,0,1,2.8.15,10,10,0,0,0,1.71.09c8.93-.22,29.63-8.35,29.63-8.35s-7.4-24.35,10-41.29c13.62-13.3,15.52-26.47,15.71-31.53A16,16,0,0,0,989.53,504.21Z",
    transform: "translate(-22.3 -51.76)"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M797.87,455.47s-29-20.12-31.13-2S797.87,469,797.87,469Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#a5636d"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M847.87,442.13s-15.69,10.38-24.37,9.74c0,0-23.72,3.18-26.48,1.59s-4.44,23-4.44,23l39-2.75,25-3.82s12.5-7.62,12.5-14.19S847.87,442.13,847.87,442.13Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#f7cddd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M847.87,442.13s-15.69,10.38-24.37,9.74c0,0-23.72,3.18-26.48,1.59s-4.44,23-4.44,23l39-2.75,25-3.82s12.5-7.62,12.5-14.19S847.87,442.13,847.87,442.13Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.05
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M824.86,494.49s-35.27-1.46-27.37,15,34.63-3.52,34.63-3.52Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#a5636d"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M860.34,459.5s-28.59-21.39-24.56-47.44S860.34,432,860.34,432Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#5c5c8e"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M852.44,341.4a36.18,36.18,0,0,1-10.17,25.11,34,34,0,0,1-5.22,4.45,37.29,37.29,0,0,1-11.86,5.48,37.68,37.68,0,0,1-5.13.91c-1.24.12-2.49.19-3.76.19a35.26,35.26,0,0,1-11.91-2,36.14,36.14,0,1,1,48.05-34.1Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#a5636d"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M989.57,506.33c-3.24.6-7.24,1.68-7.24,3.36,0,2.83-45.18,18.08-45.18,18.08s1.69,3.94-2.82,10.72-41.23,45.74-41.23,45.74l.12,1.16.47,4.49,2.24,21.46s-14.12-5.08-18.64-4.52c-1.46.19-3-.75-4.51-2.1a21.84,21.84,0,0,1,3-7.22s3.66-2.88,9.18-6.69v-72l95.93-23.29,8.69,8.65A16,16,0,0,1,989.57,506.33Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M993.63,502.35s-11.3,1.12-11.3,3.95-45.18,18.08-45.18,18.08,1.69,3.94-2.82,10.72-41.23,45.75-41.23,45.75l2.83,27.1s-14.12-5.08-18.64-4.52c-2,.25-4.25-1.61-6.1-3.78a39.34,39.34,0,0,1-4.07-5.81s5.09-21.47-1.69-26.55,7.34-42.35,7.34-42.35,6.38-26.5,4.5-37.87a13.64,13.64,0,0,0-.54-2.24c0-.08-.05-.17-.08-.25-4-10.86-47.36-102-47.36-102a65.48,65.48,0,0,1,.54-7.73c.09-.71.21-1.45.34-2.2a37.28,37.28,0,0,1,.88-4,25,25,0,0,1,.82-2.49c1.34-3.44,3.39-6.09,6.45-6.15,0,0,3.39-3.75,11.34-4.77,5.82-.76,14.13,0,25.38,4.77,26.53,11.28,32.75,11.86,32.75,11.86l13.33,17.5,2.74,3.59a345.89,345.89,0,0,1,27.21,41.3c4.44,8,10.73,17.29,18.27,22.88C984.59,468.47,993.63,502.35,993.63,502.35Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#f7cddd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M894.65,437.05s37.7,9.32,52.31,32.82Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M906.3,478.34s7.13,47.87,5.15,51.47S906.3,478.34,906.3,478.34Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M903.75,502.91c-2.74,3.59-13.87,31.34-13.87,31.34l3.21,46.6,2.83,27.1s-14.11-5.08-18.63-4.52c-2,.25-4.26-1.61-6.1-3.78,2.93-15.87,9.2-49.08,10.33-49.72,1.49-.85,9.12-27.53,9.52-35s11-24.12,11-24.12S906.51,499.32,903.75,502.91Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M893.1,457.17c-.7,2.11-1.78,14.4-1.78,14.4-.78,10.82-9,14.36-14.05,15.5a13.64,13.64,0,0,0-.54-2.24c-3.39-9.59-47.44-102.21-47.44-102.21a60.85,60.85,0,0,1,1.76-13.94c9.59-2.82,24.77,1.52,24.77,1.52,4.39-.58,18.71,27.89,18.71,27.89s9.54,21.8,10.59,24.77,0,7.84.42,9.54,4.88,3.16,5.51,5.5.22,7,.64,7.83S893.81,455.05,893.1,457.17Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M889.71,455.47c-.7,2.12-1.78,14.4-1.78,14.4-.64,9-6.44,13-11.28,14.71a23.64,23.64,0,0,1-6.78,1.35l-6.81,5.92L831.61,515s-11.72-21.67-8.54-21.79,21.52-15.52,21.52-15.52c5.61-3,11.23-13,13.84-18.14a15.85,15.85,0,0,1-.34-1.86c-1.13-9.59-24.85-46.31-24.85-46.31s-9.17-10.79-12.74-30.78c-.1-.46-.17-.93-.26-1.41a14.34,14.34,0,0,1-.18-1.88c-.43-7.69,5.17-10.49,11.81-11.15h0a47.4,47.4,0,0,1,10.4.32,75.29,75.29,0,0,1,10.17,2c2.84-.38,9.84,11.43,14.43,19.8h0c2.47,4.54,4.25,8.08,4.25,8.08s9.54,21.81,10.59,24.77,0,7.85.42,9.54,4.88,3.17,5.51,5.51.22,7,.64,7.83S890.42,453.35,889.71,455.47Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#f7cddd"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M926.19,406.61c-6,6.13-15.69,6.15-23.47,3s-14.37-8.79-21.58-13.18c-4.68-2.86-9.64-5.2-14.25-8.15h0c-.68-.44-1.34-.88-2-1.34-5.32-3.76-9.93-8.59-15.44-12a24,24,0,0,0-12.4-4,14.1,14.1,0,0,0-5.91,1.24,8,8,0,0,0-1,.49,25.5,25.5,0,0,0-5,3.75c-1.56,1.4-3.05,2.89-4.69,4.2-.1-.46-.17-.93-.26-1.41a14.34,14.34,0,0,1-.18-1.88c-1.24.12-2.49.19-3.76.19a35.26,35.26,0,0,1-11.91-2c0-.15,0-.3-.09-.45-1.35-7.12-3.79-14.66-9.52-18.66-3.32-2.32-8.62-3.27-13.22-5a36.14,36.14,0,1,1,68.1,3.91c5.82-.76,14.13,0,25.38,4.77,26.53,11.28,32.75,11.86,32.75,11.86l13.33,17.5c-1.44,2.2-3.07,4.37-3.22,6.94C917.6,401.1,922.19,404.39,926.19,406.61Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M794.77,353c5.73,4,8.17,11.53,9.53,18.64.42,2.22.82,4.56,2.18,6.32,3,3.94,9.16,2.83,13.13,0s7.1-7.12,11.53-9.12c5.88-2.66,12.8-.72,18.31,2.73s10.12,8.28,15.44,12c5.15,3.63,10.89,6.22,16.25,9.49,7.21,4.39,13.8,10.06,21.58,13.18s17.5,3.11,23.46-3c-4-2.22-8.59-5.5-8.28-10.26s5.85-8.31,5.48-13.19-6.11-6.79-10.23-9.19c-8.6-5-12.27-16-14.11-26.15-1.43-7.94-2.61-16.81-8.54-21.91-3.83-3.28-9-4.35-12.86-7.6-3.65-3.09-5.68-7.76-8-12.07-3.83-7.17-8.86-13.84-15.51-18.13s-15.11-6-22.41-3.06c-2.8,1.11-5.35,2.83-8.11,4-6.88,3-14.75,2.57-21.56,5.7-8.39,3.86-13.84,12.38-18.83,20.47C779,318.78,770.63,331,773,340,775.36,349.15,788.55,348.66,794.77,353Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#4c3e42"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M923.37,379.24a6.31,6.31,0,0,0-.19-1.1c-1.52,2.39-3.41,4.71-3.59,7.51a6.81,6.81,0,0,0,.16,1.93C921.44,384.89,923.61,382.36,923.37,379.24Z",
    transform: "translate(-22.3 -51.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.41,398.94c-7.78-3.12-14.36-8.79-21.57-13.18-5.37-3.27-11.11-5.86-16.26-9.49-5.32-3.76-9.93-8.59-15.44-12s-12.42-5.39-18.31-2.74c-4.43,2-7.55,6.25-11.53,9.13s-10.08,4-13.13,0c-1.36-1.76-1.76-4.1-2.18-6.32-1.35-7.11-3.8-14.64-9.52-18.64-6.23-4.35-19.42-3.86-21.81-13a14.2,14.2,0,0,1-.31-5c-1.53,4.08-2.32,8.18-1.39,11.75,2.4,9.18,15.59,8.69,21.81,13,5.73,4,8.17,11.54,9.53,18.65.42,2.22.82,4.56,2.17,6.32,3,3.94,9.16,2.83,13.14-.05s7.09-7.12,11.53-9.12c5.88-2.65,12.8-.71,18.31,2.74s10.12,8.28,15.44,12c5.15,3.64,10.89,6.22,16.25,9.49,7.21,4.4,13.8,10.07,21.58,13.19s17.5,3.1,23.46-3a28.72,28.72,0,0,1-4.37-2.89C916.39,401.77,909.92,401.15,904.41,398.94Z",
    transform: "translate(-22.3 -51.76)"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M727.42,467.34l80-29.88a7.6,7.6,0,0,1,9.79,4.46h0a7.61,7.61,0,0,1-4.47,9.79l-80,29.89-17.14-1.72Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#5c5c8e"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M814.78,439.52h0a7.62,7.62,0,0,1-4.47,9.8l-80,29.88-12.88-1.29-1.85,2,17.14,1.72,80-29.89a7.61,7.61,0,0,0,4.47-9.79h0a7.58,7.58,0,0,0-3.11-3.8A8.28,8.28,0,0,1,814.78,439.52Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#fff",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "705.12 415.58 710.45 429.84 696.38 428.43 693.3 428.12 697.51 423.66 705.12 415.58",
    fill: "#efc8c4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M719.8,475.42a3.05,3.05,0,0,1,.82.9,1.29,1.29,0,0,1,0,1.39,3.13,3.13,0,0,1-.78.55,2.55,2.55,0,0,0-1.14,1.93l-3.08-.31Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#727a9c"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M657.59,312.83l-13.49-6.58a1.63,1.63,0,0,1-.75-2.18l1.43-2.94a1.62,1.62,0,0,1,2.18-.75l9.09,4.43,9.49-19.46a1.64,1.64,0,0,1,2.18-.76l2.94,1.44a1.62,1.62,0,0,1,.75,2.18l-11.64,23.87a1.63,1.63,0,0,1-2.18.75Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#3acc6c"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M687.06,397l-13.49-6.58a1.63,1.63,0,0,1-.75-2.18l1.43-2.94a1.64,1.64,0,0,1,2.19-.75l9.08,4.43L695,369.5a1.64,1.64,0,0,1,2.18-.76l2.93,1.44a1.63,1.63,0,0,1,.76,2.18l-11.64,23.87a1.65,1.65,0,0,1-2.19.75Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#3acc6c"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M673.83,355.51l-13.49-6.58a1.64,1.64,0,0,1-.76-2.18l1.44-2.94a1.62,1.62,0,0,1,2.18-.75l9.09,4.43L681.78,328a1.63,1.63,0,0,1,2.18-.75l2.94,1.43a1.65,1.65,0,0,1,.75,2.19L676,354.76a1.63,1.63,0,0,1-2.18.75Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#3acc6c"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M699.86,435l-13.49-6.58a1.63,1.63,0,0,1-.75-2.18l1.43-2.94a1.63,1.63,0,0,1,2.18-.75l9.09,4.43,9.49-19.46a1.65,1.65,0,0,1,2.19-.76l2.93,1.44a1.62,1.62,0,0,1,.75,2.18l-11.63,23.87a1.65,1.65,0,0,1-2.19.75Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#3acc6c"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M195.52,693.36s5.95,7.78-2.74,19.52-15.87,21.66-13,29c0,0,13.12-21.81,23.79-22.11S207.26,706.48,195.52,693.36Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#3acc6c"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M195.52,693.36a9.59,9.59,0,0,1,1.22,2.44c10.41,12.24,16,23.66,5.95,24-9.33.26-20.52,16.94-23.19,21.15a7.68,7.68,0,0,0,.31,1s13.12-21.81,23.79-22.11S207.26,706.48,195.52,693.36Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M206.58,703.28c0,2.73-.31,5-.69,5s-.68-2.22-.68-5,.38-1.45.76-1.45S206.58,700.54,206.58,703.28Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ffd037"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M210.37,706.54c-2.4,1.31-4.5,2.11-4.68,1.77s1.62-1.66,4-3,1.45-.36,1.63,0S212.78,705.23,210.37,706.54Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ffd037"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M164.1,693.36s-5.94,7.78,2.75,19.52,15.86,21.66,13,29c0,0-13.11-21.81-23.79-22.11S152.36,706.48,164.1,693.36Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#3acc6c"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M164.1,693.36a9.81,9.81,0,0,0-1.21,2.44c-10.42,12.24-16,23.66-5.95,24,9.32.26,20.51,16.94,23.19,21.15a7.72,7.72,0,0,1-.32,1S166.7,720.05,156,719.75,152.36,706.48,164.1,693.36Z",
    transform: "translate(-22.3 -51.76)",
    opacity: 0.1
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M153.05,703.28c0,2.73.3,5,.68,5s.69-2.22.69-5-.38-1.45-.76-1.45S153.05,700.54,153.05,703.28Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ffd037"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M149.25,706.54c2.41,1.31,4.5,2.11,4.68,1.77s-1.62-1.66-4-3-1.46-.36-1.64,0S146.85,705.23,149.25,706.54Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#ffd037"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.52,
    cy: 740.06,
    rx: 62.19,
    ry: 9.54,
    fill: "#ec6374",
    opacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M211.82,731.38l-.3,2.43-.41,3.43-.18,1.43-.41,3.43-.19,1.43-.41,3.43-4.76,39c-.43,3.48-6.12,6.2-13,6.2H167.45c-6.87,0-12.55-2.72-13-6.2l-4.76-39-.42-3.43-.17-1.43-.43-3.43-.17-1.43-.42-3.43-.3-2.43c-.23-2,2.84-3.64,6.73-3.64H205.1C209,727.74,212.07,729.41,211.82,731.38Z",
    transform: "translate(-22.3 -51.76)",
    fill: "#65617d"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "189.23 682.05 188.81 685.48 126.22 685.48 125.81 682.05 189.23 682.05",
    fill: "#9d9cb5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.64 686.91 188.22 690.34 126.82 690.34 126.4 686.91 188.64 686.91",
    fill: "#9d9cb5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.04 691.77 187.62 695.2 127.41 695.2 126.99 691.77 188.04 691.77",
    fill: "#9d9cb5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo);
export default __webpack_public_path__ + "static/media/todo.6713a8d42fd5904d9870df25900ff5ac.svg";
export { ForwardRef as ReactComponent };